var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 48,
    viewBox: "0 0 53 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12042_2016)",
    filter: "url(#filter0_d_12042_2016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4626 38.8096H39.837C39.2546 38.8096 38.7842 38.3392 38.7842 37.7568V9.60642C38.7874 9.02722 39.2578 8.56002 39.837 8.55682H47.4626C48.0418 8.55682 48.5154 9.02402 48.5186 9.60642V37.7568C48.5186 38.336 48.0514 38.8096 47.469 38.8096C47.469 38.8096 47.469 38.8096 47.4658 38.8096H47.4626Z",
    fill: "url(#paint0_linear_12042_2016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.115 38.9152L5.30223 35.4848C4.78383 35.2224 4.57263 34.592 4.83503 34.0704L17.4718 8.9312C17.7342 8.4128 18.3646 8.2016 18.8862 8.464L25.699 11.888C26.2174 12.1504 26.4286 12.7808 26.1662 13.3024L13.5262 38.448C13.2638 38.9664 12.6334 39.1776 12.1118 38.9152H12.115Z",
    fill: "url(#paint1_linear_12042_2016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.237 38.3488L37.6386 10.9376C37.7506 10.368 37.3826 9.81758 36.8162 9.70238L29.341 8.19198C28.7682 8.07678 28.2146 8.44798 28.0994 9.02078L22.6978 36.4352C22.5858 37.0048 22.9538 37.5552 23.5234 37.6704L30.9954 39.1776C31.565 39.2928 32.1186 38.928 32.237 38.3584V38.3488Z",
    fill: "url(#paint2_linear_12042_2016)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12042_2016",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12042_2016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12042_2016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12042_2016",
    x1: 29.533,
    y1: 28.8896,
    x2: 50.109,
    y2: 21.3024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6D00CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12042_2016",
    x1: 11.475,
    y1: 25.4304,
    x2: 33.5934,
    y2: 15.8656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E80DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C024ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B02DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12042_2016",
    x1: 6.3138,
    y1: 32.4672,
    x2: 51.6546,
    y2: 15.7728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E80DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C024ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A42BE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8527D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6021C3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12042_2016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMake);
export default __webpack_public_path__ + "static/media/make.cfdc6d50549a2b637e13c57aa5ffc326.svg";
export { ForwardRef as ReactComponent };